module.exports = "/_next/static/images/CreateOneCustomerConversation@2x-b0e19752327cad868463e4907cf8b060.png";